import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResidenceSubType } from '../../residence.model';

export interface ChangeSubTypeDialogData {
    currentSubType: ResidenceSubType;
}

@Component({
    selector: 'app-change-subtype-dialog',
    templateUrl: './change-subtype-dialog.component.html',
    styleUrls: ['./change-subtype-dialog.component.scss'],
})
export class ChangeSubTypeDialogComponent {
    public subTypeControl = new FormControl(this.data.currentSubType);

    constructor(
        public dialogRef: MatDialogRef<ChangeSubTypeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ChangeSubTypeDialogData,
    ) {}

    confirm(): void {
        this.dialogRef.close(this.subTypeControl.value);
    }

    cancel(): void {
        this.dialogRef.close(null);
    }
}
